export default {
    path: 'jsgc',
    component: () => import(/*webpackChunkName: 'bidding-projectflow-dingbiao-zhongbiaogg-jsgc'*/ '@layout/empty'),
    children: [
        {
            path:"detail",
            component: () => import('@views/bidding/views/project-flow/ding/zhongbiaogg/jsgc/detail'),
            meta: {
                title: '查看中标公告',
            },
        }        
    ]
}